<template>
  <v-container fluid text-xs-left>
    <v-layout justify-center>
      <v-card class="tarjeta">
        <v-toolbar card :color="type" dark dense>
          <v-icon>{{ icon }}</v-icon>
          <v-card-title>{{ title }} </v-card-title>
        </v-toolbar>
        <v-card-title primary-title> <slot></slot> </v-card-title>
        <slot name="texto"></slot>
        <v-card-actions> <slot name="actions"></slot> </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'MessageBox',
  props: {
    id: {
      type: String
    },
    title: {
      type: String,
      required: true
    },
    type: {
      type: String, // error-warning-success
      required: true
    }
  },
  computed: {
    icon() {
      if (this.type === 'error') {
        return 'error_outline';
      } else if (this.type === 'success') {
        return 'done';
      }
      return 'warning';
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.v-card {
  /* min-width: 200px !important; */
  width: 100% !important;
}
</style>
